import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAreas } from '../../services/Admin/areaService';
import { getRoles } from '../../services/Admin/rolService';
import { getJefes } from '../../services/Auth/userService';
import { createUser } from '../../services/Auth/userService';
import Sidebar from '../../components/Sidebar';
import '../tasks/CrearTareaPage.css';
import '../styles/FormPageStyles.css';
import withAuth from '../../routes/withAuth';

const UserPage = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    areaId: '',
    rolId: '',
    jefeInmediatoId: '',
    contrasena: '',
    confirmarContrasena: ''
  });

  const [areas, setAreas] = useState([]);
  const [roles, setRoles] = useState([]);
  const [jefes, setJefes] = useState([]);
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  // --- Sidebar Logic ---
  const links = [
    { to: '/home', label: 'Home'},
    { to: '/admin/parametros', label: 'Parametros' },
    { to: '/admin/area', label: 'Area' },
    { to: '/admin/categoria', label: 'Categoria' },
    { to: '/admin/rol', label: 'Rol' },
    { to: '/admin/tareas-area', label: 'Tareas del Área' },
    { to: '/auth/register', label: 'Crear Usuario' },
    { to: '/admin/administrar-usuarios', label: 'Administrar Usuarios' }
  ];

  const handleLogout = () => {
    localStorage.removeItem('authToken');
    navigate('/auth/login');
  };
  // --- End Sidebar Logic ---

  useEffect(() => {
    const fetchData = async () => {
      try {
        const areaData = await getAreas();
        setAreas(areaData || []);
        const rolData = await getRoles();
        setRoles(rolData || []);
        const jefesData = await getJefes();
        setJefes(jefesData || []);
      } catch (err) {
        setError('Error al cargar datos iniciales.');
        console.error(err);
      }
    };
    fetchData();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccessMessage('');

    if (!formData.rolId || !formData.contrasena || !formData.confirmarContrasena) {
      setError('Los campos (Rol, Contraseña, Confirmar Contraseña) son obligatorios.');
      return;
    }

    if (formData.contrasena !== formData.confirmarContrasena) {
      setError('Las contraseñas no coinciden.');
      return;
    }
    
    console.log('formData antes de construir payload:', formData); // Para debugging
    
    setIsSubmitting(true);
    // Construir payload solo con campos que tienen valores válidos
    const payload = {
        rolId: parseInt(formData.rolId, 10),
        contrasena: formData.contrasena
    };

    // Solo agregar areaId si tiene un valor válido
    if (formData.areaId && formData.areaId !== '') {
        payload.areaId = parseInt(formData.areaId, 10);
    }

    // Solo agregar jefeInmediatoId si tiene un valor válido
    if (formData.jefeInmediatoId && formData.jefeInmediatoId !== '') {
        payload.jefeInmediatoId = parseInt(formData.jefeInmediatoId, 10);
    }

    console.log('Payload a enviar:', payload); // Para debugging

    try {
      const result = await createUser(payload);
      if (result.success) {
        setSuccessMessage('¡Usuario creado exitosamente! Redirigiendo a Home...');
        setTimeout(() => {
          navigate('/home');
        }, 2000);
      } else {
        setError(result.message || 'Error al crear el usuario. Intente de nuevo.');
      }
    } catch (err) {
      setError('Error al enviar el formulario. Verifique la consola.');
      console.error(err);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="crear-tarea-container">
      <Sidebar links={links} onLogout={handleLogout} />
      <main className="crear-tarea-content">
        <div className="form-wrapper">
          <h2>Paso 2: Asignar Rol y Credenciales</h2>
          {error && <p className="error-message">{error}</p>}
          {successMessage && <p className="success-message">{successMessage}</p>}
          <form onSubmit={handleSubmit} className="grid-form">
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="areaId">Área (Opcional)</label>
                <select id="areaId" name="areaId" value={formData.areaId} onChange={handleChange}>
                  <option value="">Seleccione Área</option>
                  {areas.map(area => (
                    <option key={area.id_area} value={area.id_area}>{area.nombre}</option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label htmlFor="rolId">Rol*</label>
                <select id="rolId" name="rolId" value={formData.rolId} onChange={handleChange} required>
                  <option value="" disabled>Seleccione Rol</option>
                  {roles.map(rol => (
                    <option key={rol.id_rol} value={rol.id_rol}>{rol.nombre}</option>
                  ))}
                </select>
              </div>
            </div>
            <div className="form-row">
              <div className="form-group full-width">
                <label htmlFor="jefeInmediatoId">Jefe inmediato (Opcional)</label>
                <select id="jefeInmediatoId" name="jefeInmediatoId" value={formData.jefeInmediatoId} onChange={handleChange}>
                  <option value="">Seleccione un Jefe</option>
                  {jefes.map(jefe => (
                    <option key={jefe.idUsuario} value={jefe.idUsuario}>{`${jefe.nombres} ${jefe.apellidos}`}</option>
                  ))}
                </select>
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="contrasena">Contraseña*</label>
                <input type="password" id="contrasena" name="contrasena" value={formData.contrasena} onChange={handleChange} required />
              </div>
              <div className="form-group">
                <label htmlFor="confirmarContrasena">Confirmar Contraseña*</label>
                <input type="password" id="confirmarContrasena" name="confirmarContrasena" value={formData.confirmarContrasena} onChange={handleChange} required />
              </div>
            </div>
            <div className="form-row">
                <button type="submit" className="submit-button create-btn" disabled={isSubmitting}>
                  {isSubmitting ? 'Creando Usuario...' : 'Finalizar Creación de Usuario'}
                </button>
            </div>
          </form>
        </div>
      </main>
    </div>
  );
};

export default withAuth(UserPage); 